// Frequency caps for interruptive growth surfaces (exit-intent modal,
// scroll-triggered rails). Rule enforced site-wide: at most ONE interruptive
// element per page, and once a visitor has seen or dismissed one it stays
// quiet for a cooldown window. All storage is localStorage, so this is
// client-only; every function no-ops safely during SSR.

const PREFIX = 'idk-growth:'

/** Days a dismissed/shown surface stays quiet. */
const SHOWN_COOLDOWN_DAYS = 7
/** Days a converted surface (booked demo, submitted email) stays quiet. */
const CONVERTED_COOLDOWN_DAYS = 90

function read(key: string): number | null {
  if (typeof window === 'undefined') return null
  try {
    const raw = window.localStorage.getItem(PREFIX + key)
    return raw ? Number(raw) : null
  } catch {
    return null
  }
}

function write(key: string, value: number) {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(PREFIX + key, String(value))
  } catch {
    /* storage full / private mode: fail open, the cap just won't persist */
  }
}

/** True when the surface hasn't fired inside its cooldown window. */
export function canShow(key: string): boolean {
  const shown = read(key)
  const converted = read(key + ':converted')
  const now = Date.now()
  if (converted && now - converted < CONVERTED_COOLDOWN_DAYS * 86_400_000) return false
  if (shown && now - shown < SHOWN_COOLDOWN_DAYS * 86_400_000) return false
  return true
}

export function markShown(key: string) {
  write(key, Date.now())
}

export function markConverted(key: string) {
  write(key + ':converted', Date.now())
}
